export const TEACHER_VIDEO_OFF =
  "Please wait for the instructor to switch on the video";

export const USER_WENT_OFFLINE = "User went offline";

export const USER_VIDEO_OFF = "User's video is switched off";

export const YOUR_VIDEO_OFF = "Your video is switched off";

export const EXTERNALLY_MUTED = "You were muted by the instructor";

export const ANONYMOUS = "Anonymous";

export const TEACH_DOMAIN_NO_ACTIVE_USER =
  "Your're about to go online. Game face on!";

export const LEARN_DOMAIN_NO_ACTIVE_USER =
  "Please wait for the instructor to come online";
